import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PopoverService} from '../../../components/popover/popover.service';
import {
    ToolbarNotificationsDropdownComponent
} from './toolbar-notifications-dropdown/toolbar-notifications-dropdown.component';
import {Subject, takeUntil} from "rxjs";
import {NotificationsManagerService} from "@core/services/notifications/notifications-manager.service";

@Component({
    selector: 'vex-toolbar-notifications',
    templateUrl: './toolbar-notifications.component.html',
    styleUrls: ['./toolbar-notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarNotificationsComponent implements OnInit, OnDestroy {

    private readonly destroying$ = new Subject<void>();
    @ViewChild('originRef', {static: true, read: ElementRef}) originRef: ElementRef;
    length: number = 0;
    dropdownOpen: boolean;
    private unsub = new Subject<void>();

    constructor(
        private popover: PopoverService,
        private notificationsManager: NotificationsManagerService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit() {
        // Suscribirse al conteo de no leídas
        this.notificationsManager.getUnreadCount()
            .pipe(takeUntil(this.destroying$))
            .subscribe(count => {
                this.length = count;
                          this.cd.detectChanges();
                          this.cd.markForCheck();
            });

        // Iniciar polling si no está activo
        this.notificationsManager.startPolling();
    }

    ngOnDestroy() {
        this.destroying$.next();
        this.destroying$.complete();
        this.unsub.next();
        this.unsub.complete();
    }

    showPopover() {
        this.dropdownOpen = true;
        this.cd.markForCheck();

        const popoverRef = this.popover.open({
            content: ToolbarNotificationsDropdownComponent,
            origin: this.originRef,
            offsetY: 12,
            position: [
                {
                    originX: 'center',
                    originY: 'top',
                    overlayX: 'center',
                    overlayY: 'bottom'
                },
                {
                    originX: 'end',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'top',
                },
            ]
        });

        popoverRef.afterClosed$.subscribe(() => {
            this.dropdownOpen = false;
            this.cd.markForCheck();
        });
    }
}
